import basicMixin from '../../../../assets/mixins/basic';
import { optionChar, keyboardFix } from '../../../../assets/utils/utils';
import { nl2br } from '@polyv/utils/src/string';
export default {
  mixins: [basicMixin],
  props: {
    question: {
      type: Object,
      required: true,
    },
    index: {
      type: [Number, String],
      default: 0
    },
    answer: {
      type: String,
      default: ''
    },
    isWebView: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      values: null,
      // 五星评分当前选择的下标
      curStarIndex: -1,
      // 10分评分当前选择的下标
      curCircleIndex: -1,
      titleStatus: 'expand',
      isTitleOverflow: false,
      // 用户填写的填空题答案
      userFillInBlankAnswer: [],
    };
  },
  watch: {
    values() {
      let selectedAnswer = this.values;
      const type = this.question.type;
      if (type === 'C') {
        selectedAnswer = this.values.join('');
      } else if (type === 'X' || type === 'S') {
        selectedAnswer = this.values > 0 ? String.fromCharCode(64 + this.values) : '';
      }
      this.$emit('select', {
        questionId: this.question.questionId,
        answer: selectedAnswer
      });
    },
    question() {
      if (this.question.type === 'D' && this.isMobile) {
        this.checkTitleHeight();
      }
    },
    userFillInBlankAnswer() {
      this.$emit('select', {
        questionId: this.question.questionId,
        answer: this.userFillInBlankAnswer.join(',')
      });
    }
  },
  computed: {
    isFillInBlankQuestion() {
      return this.question.type === 'T';
    },
    /**
     * 填空题标题二次处理，将填空符替换成输入框供用户填写
     */
    fillInBlankQuestionName() {
      if (!this.isFillInBlankQuestion || !this.question.name) return [];
      // 你<t>对<t>评价如何？<t>，将 <t> 解析为 input 输入框
      const nameArr = this.question.name.split(/(<t(?:\s+[a-zA-Z_]+='[^']*')*\s*>)/g).map(part => {
        return {
          isBlank: /<t(?:\s+[a-zA-Z_]+='[^']*')*\s*>/.test(part),
          text: !/<t(?:\s+[a-zA-Z_]+='[^']*')*\s*>/.test(part) ? part.replace(/\n/g, '<br/>') : ''
        };
      }).filter(item => item.isBlank || Boolean(item.text));

      // userFillInBlankAnswer 必须初始化成和填空符数量一致的数组，不然 v-model 变化时无法触发更新
      const blankItemNum = nameArr.filter(item => item.isBlank).length;
      this.userFillInBlankAnswer = new Array(blankItemNum).fill('');

      // 重新排列填空符的索引，这是为了用户填写答案时，答案的顺序和填空符的顺序一致
      let blankIndex = 0;
      nameArr.forEach(item => {
        if (item.isBlank) {
          item.blankIndex = blankIndex++;
        }
      });
      return nameArr;
    },
  },
  mounted() {
    // 当题目为多选题时
    if (this.question.type === 'C') {
      this.values = [];
    }
    if (this.question.type === 'D' && this.isMobile) {
      this.checkTitleHeight();
    }
  },
  methods: {
    optionChar,
    keyboardFix,
    checkTitleHeight() {
      this.$nextTick(() => {
        const lineHeight = 24;
        const titleHeight = this.$refs.questionTitle.offsetHeight;
        if (titleHeight > lineHeight * 3) {
          this.isTitleOverflow = true;
          this.titleStatus = 'contract';
        } else {
          this.isTitleOverflow = false;
          this.titleStatus = 'expand';
        }
      });

    },
    changeTitleStatus() {
      if (this.titleStatus === 'expand') {
        this.titleStatus = 'contract';
      } else {
        this.titleStatus = 'expand';
      }
    },
    formatQName(index, question) {
      const name = nl2br(question.name);
      return `${index + 1}.${this.questionType(question)} ${name}`;
    },
    questionType(question) {
      let typeText = '';
      if (question.type === 'R') {
        typeText = this.iarTrans(`${this.langName}.singleChoice`);
      } else if (question.type === 'C') {
        typeText = this.iarTrans(`${this.langName}.multiChoice`);
      } else if (question.type === 'Q') {
        typeText = this.iarTrans(`${this.langName}.askQuestion`);
      } else if (question.type === 'X' || question.type === 'S') {
        typeText = this.iarTrans(`${this.langName}.evaluate`);
      } else if (question.type === 'J') {
        typeText = this.iarTrans(`${this.langName}.judgement`);
      } else if (question.type === 'T') {
        typeText = this.iarTrans(`${this.langName}.fillInBlank`);
      }

      return typeText;
    },
    onBlur() {
      if (this.isWebView) {
        this.keyboardFix();
      }
    },
    slectOption(optionIndex) {
      const answer = optionChar(optionIndex);
      this.$emit('select', answer);
    }
  }
};
